/**
 * Slugs legacy → canónico (renames de demos / tenants).
 * Usar en loaders, beforeLoad y middleware para no romper bookmarks.
 */
export const STOREFRONT_SLUG_ALIASES: Readonly<Record<string, string>> = {
  burgerbosch: "americanburger",
  "burger-bosch": "americanburger",
};

export function canonicalStorefrontSlug(slug: string): string {
  return STOREFRONT_SLUG_ALIASES[slug] ?? slug;
}

/** Si el path es /market/<legacy>/… → path canónico (sin origin). */
export function canonicalMarketPath(pathname: string): string | null {
  const m = pathname.match(/^\/market\/([^/]+)(\/.*)?$/);
  if (!m) return null;
  const legacy = m[1];
  const canonical = canonicalStorefrontSlug(legacy);
  if (canonical === legacy) return null;
  return `/market/${canonical}${m[2] ?? ""}`;
}
